import React from "react";

export default function MSAccess_Environ() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Environ</h1>
      <p>This is the MSAccess_Environ component generated from the SQL JSON.</p>
    </div>
  );
}
